import React from 'react';
import { Routes, Route } from 'react-router-dom';
import GaApp from './GA/App';
import MldeApp from './MLDE/components/App';
import NotFound from './Common/components/NotFound/NotFound';
import Error from './Common/components/Error/Error';

const App = () => {
  return (
    <Routes>
      <Route path="/ga/*" element={<GaApp />} />
      <Route path="/mlde/*" element={<MldeApp />} />
      <Route path="/error" element={<Error />} />
      <Route path="/notfound" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
